"use strict";

export default [
  "$rootScope",
  "$scope",
  "InvestPlanService",
  "IndustryRestService",
  "MunicipalityRestService",
  function (
    $rootScope,
    $scope,
    InvestPlanService,
    IndustryRestService,
    MunicipalityRestService
  ) {
    $scope.loading = false;
    $scope.localFilter = InvestPlanService.localFilter;
    $scope.data = {
      resultData: [],
      okvedData: [],
    };
    $scope.municipalities = [];
    $scope.industries = [
      {
        id: null,
        name: "Не выбрано",
      },
    ];
    $scope.sources = [
      {
        id: null,
        name: "Не выбрано",
      },
      {
        id: "federal",
        name: "Федеральный бюджет",
      },
      {
        id: "regional",
        name: "Региональный бюджет",
      },
      {
        id: "municipal",
        name: "Местный бюджет",
      },
      {
        id: "own",
        name: "Внебюджетные средства",
      },
    ];
    $scope.years = Array(100)
      .fill(null)
      .map((_, index) => ({
        id: 2000 + index,
        name: 2000 + index,
      }));
    $scope.loadData = loadData;

    init();

    function init() {
      $rootScope.title = "";
      loadMunicipalities();
      loadIndustries();
      loadData();
    }

    function prettyNumericValue(value) {
      return value
        ? value
            .toLocaleString("ru-RU", { maximumFractionDigits: 2 })
            .replace(",", ".")
        : 0;
    }

    function loadMunicipalities() {
      return MunicipalityRestService.get({
        filters: [`'status' EQ 'ENABLED'`],
        sorts: ["npp:ASC", "name:ASC"],
      }).$promise.then((data) => ($scope.municipalities = data._embedded));
    }

    function loadIndustries() {
      return IndustryRestService.get({
        filters: [`'status' EQ 'ENABLED'`],
        sorts: ["npp:ASC", "name:ASC"],
      }).$promise.then((data) => $scope.industries.push(...data._embedded));
    }

    const validateProjectItems = function (items) {
      const itemsLength = items.length;
      if (!Array.isArray(items) || itemsLength === 0) return [];

      const summaryItem = items.reduce(
        (acc, n) => {
          acc.total += n.total || 0;
          acc.municipalBudget += n.municipalBudget || 0;
          acc.localBudget += n.localBudget || 0;
          acc.offBudget += n.offBudget || 0;
          acc.outputs += n.outputs || 0;
          acc.turnover += n.turnover || 0;
          acc.services += n.services || 0;
          acc.workplaces += n.workplaces || 0;
          return acc;
        },
        {
          year: "всего",
          total: 0,
          municipalBudget: 0,
          localBudget: 0,
          offBudget: 0,
          outputs: 0,
          turnover: 0,
          services: 0,
          workplaces: 0,
        }
      );

      return (itemsLength > 1 ? [summaryItem, ...items] : items).map((n) => ({
        year: n.year,
        total: prettyNumericValue(n.total),
        municipalBudget: prettyNumericValue(n.municipalBudget),
        localBudget: prettyNumericValue(n.localBudget),
        offBudget: prettyNumericValue(n.offBudget),
        outputs: prettyNumericValue(n.outputs),
        turnover: prettyNumericValue(n.turnover),
        services: prettyNumericValue(n.services),
        workplaces: prettyNumericValue(n.workplaces),
        empty: n.empty,
      }));
    };

    function trimOkveds(okveds) {
      if (typeof okveds !== "string" || okveds.length < 150) return null;
      return `${okveds.slice(0, 120)}...`;
    }

    function loadData() {
      $scope.loading = true;
      return InvestPlanService.api
        .getAll({
          filters: InvestPlanService.collectFilters($scope.localFilter),
        })
        .$promise.then((data) => {
          if (data.code !== 200) {
            $scope.data = {
              resultData: [],
              okvedData: [],
            };
          }
          const embedded = data._embedded || {};
          let projectNumber = 0;
          $scope.data = {
            resultData: [
              {
                okvedName: "Итоги по инвестиционным проектам",
                items: embedded.projectResults
                  ? validateProjectItems(embedded.projectResults.items)
                  : [],
              },
              {
                okvedName: "Текущая инвестиционная деятельность",
                items: embedded.activityResults
                  ? validateProjectItems(embedded.activityResults.items)
                  : [],
              },
              {
                okvedName:
                  "Итоги по инвестиционному плану\n(итоги по инвестиционным проектам + текущая инвестиционная деятельность)",
                items: embedded.planResults
                  ? validateProjectItems(embedded.planResults.items)
                  : [],
              },
            ],
            okvedData: (embedded.undefinedData
              ? [...embedded.okvedData, embedded.undefinedData]
              : embedded.okvedData
            ).map((n) => ({
              okvedCode: n.okvedCode || "НЕ ОПРЕДЕЛЕН",
              okvedName: n.okvedName,
              result: n.result ? validateProjectItems(n.result.items) : [],
              projects: (n.projects || []).map((project) => {
                projectNumber++;
                project.number = projectNumber;
                project.shortOkveds = (
                  (project.okveds || "").match(/[\d\.]+|[A-Z]/g) || []
                ).join(", ");
                project.trimOkveds = trimOkveds(project.okveds);
                project.items = validateProjectItems(project.items);
                return project;
              }),
            })),
          };
          $scope.loading = false;
        })
        .catch(() => {
          $scope.data = {
            resultData: [],
            okvedData: [],
          };
          $scope.loading = false;
        });
    }

    $scope.handleIndustryChange = function () {
      // Проверяем массив выбранных отраслей
      if (!Array.isArray($scope.localFilter.industry)) {
        return;
      }

      // Получаем индекс опции "Не выбрано"
      const notSelectedIndex = $scope.localFilter.industry.findIndex(
        (item) => item.id === null
      );

      // Если опция "Не выбрано" выбрана и есть другие выбранные опции
      if (notSelectedIndex !== -1 && $scope.localFilter.industry.length > 1) {
        // Если "Не выбрано" была выбрана последней, очищаем все остальные
        if (
          $scope.localFilter.industry[$scope.localFilter.industry.length - 1]
            .id === null
        ) {
          $scope.localFilter.industry = [
            $scope.localFilter.industry[notSelectedIndex],
          ];
        } else {
          // Иначе убираем "Не выбрано" из выбора
          $scope.localFilter.industry.splice(notSelectedIndex, 1);
        }
      }
    };

    $scope.$watch(
      "localFilter.industry",
      function (newValue, oldValue) {
        if (newValue !== oldValue && Array.isArray(newValue)) {
          $scope.handleIndustryChange();
        }
      },
      true
    );

    $scope.$watch(
      "localFilter",
      function (nv, oldv) {
        if (angular.equals(nv, oldv)) return;
        $scope.loadData();
      },
      true
    );
  },
];
